let labelId = 0;

export const getLabelId = (prefix = 'input') => {
  labelId++;
  return `${ prefix }_${ labelId }`;
};
